import type { MulticolorValue } from '@elfsight/configurator-contracts';
import { meta } from '../../constants';

const DEFAULT_COLOR = 'rgb(0, 149, 246)';
const NATIVE_TIKTOK_COLOR = 'rgb(32, 213, 236)';

export const getVerifiedBadgeColor = (
  colorSettings?: MulticolorValue,
  isMulticolor?: boolean
) => {
  const { alias } = meta;

  if (alias === 'social-feed') {
    return DEFAULT_COLOR;
  }

  if (isMulticolor) {
    return 'transparent';
  }

  const defaultColor =
    alias === 'tiktok-feed' ? NATIVE_TIKTOK_COLOR : DEFAULT_COLOR;

  return colorSettings?.type === 'custom'
    ? (colorSettings?.color ?? defaultColor)
    : defaultColor;
};
